import { useContext } from "react";
import { notification } from "antd";
import { useRecoilState, useRecoilValue } from "recoil";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getRequest, handleResponse, postFormRequest, postFormRequests, postRequest, putFormRequest, putRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import authAtom from "../../atoms/auth/auth.atom";


export function useGetProfile() {
  const url = "/Authentication/GetUserDetails";
  const axios = useContext(AxiosContext);
  const [auth, setAuth] = useRecoilState(authAtom)
  return useQuery(["get:user_profile"], () => getRequest(axios, url), {
    onSuccess: (response) => {
      handleResponse(
        response,
        () => {
          const isSubExpire = response.data.userType === "InsuranceCompany" && (!response?.data?.subscriptionProfile || response?.data?.subscriptionProfile?.isExpired)
          setAuth({
            ...auth,
            user: { ...auth?.user, data: { ...auth?.user?.data, ...response?.data }},
            isSubExpire
          })
        },
      )
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
    retry: 2,
  });
}

// export function useSetProfile() {
//   const url = "/Authentication/EditProfile";
//   const queryClient = useQueryClient()
//   const axios = useContext(AxiosContext);
//   return useMutation((payload) => postFormRequest(axios, url, payload), {
//     onSuccess: (response) => {
//       handleResponse(
//         response,
//         () => {
//           notification.success({
//             message: "Success!",
//             description: response?.message || "profile set successfully.",
//           })
//           queryClient.invalidateQueries("get:user_profile")
//         }
//       )
//     },
//     onError: (error) => notification.error({
//       message: "Error!",
//       description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
//     }),
//   });
// }

export function useSetProfile(successAction) { // /api/v1/Insurance/CreateInsuranceCompany
  const url = "/Authentication/EditProfile"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => postFormRequests(url, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useSetPicture() {
  const url = "/api/profile-image";
  const queryClient = useQueryClient()
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => putFormRequest(url, payload, user?.token), {
    onSuccess: (response) => {
      notification.success({
        message: "Success!",
        description: response?.message || "profile picture set successfully.",
      })
      queryClient.invalidateQueries("get:user_profile")
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useSetPassword() {
  const url = "/Authentication/ChangePassword";
  const queryClient = useQueryClient()
  const axios = useContext(AxiosContext)
  return useMutation((payload) => putRequest(axios, url, payload), {
    onSuccess: (response) => {
      notification.success({
        message: "Success!",
        description: response?.message || "password set successfully.",
      })
      queryClient.invalidateQueries("get:user_profile")
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}